import styled from 'styled-components';
import { ReactComponent as Back } from '../../assets/icons/back-icon-mobile.svg';
import { ReactComponent as Alert } from '../../assets/icons/alert-without-circle.svg';
import { ReactComponent as Pix } from '../../assets/icons/pix.svg';
import { ReactComponent as BarCode } from '../../assets/icons/bar-code.svg';
import { BiCreditCard } from 'react-icons/bi';

export const IconPix = styled(Pix)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconBarCode = styled(BarCode)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconCreditCard = styled(BiCreditCard)`
  width: 32px;
  height: 32px;
  color: #000;
  margin-right: 5px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconAlert = styled(Alert)`
  width: 25px;
  height: 22px;
  color: ${(props) => props.theme.colors.secundary};

  circle {
    display: hidden;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container2 = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }

  .footer {
    display: flex;
    justify-content: space-between;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 960px) {
    border-radius: 0;
    width: 100%;
    justify-content: flex-start;
  }
`;

export const IconBack = styled(Back)`
  display: none;

  @media screen and (max-width: 960px) {
    display: flex;
    width: 24px;
    height: 24px;
    margin-top: 6px;
  }
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primaryDark2};
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin: 3px 0px 28px 15px;
  }
`;

export const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 0 20px 0;

  @media screen and (max-width: 960px) {
    width: 100%;
    border-radius: 0;
  }
`;

export const Subtitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 2px;

  @media screen and (max-width: 960px) {
    margin-bottom: 4px;
    font-size: 20px;
  }
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;

  .confirmText {
    font-family: Font Awesome 5 Free;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #7b86a3;
    margin: 0 2px 0 4px;
  }

  .datepicker-box {
    width: fit-content;
    display: flex;
    align-items: center;
  }
  .number {
    color: ${(props) => props.theme.colors.primaryDark2};
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
  }

  .bank-name {
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;
  }

  .default {
    display: flex;
    font-weight: 400;
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;
    line-height: 130%;
    span {
      margin-left: 5px;
    }
  }

  .default2 {
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;

    span {
      font-weight: 700;
    }
  }

  .space-right {
    margin-right: 4px;
  }

  .space-left {
    margin-left: 4px;
  }

  .contentText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0px 15px;
  }

  .spanContent {
    margin-bottom: 2px;
    color: ${(props) => props.theme.colors.gray};
    font-size: 12px;
  }

  .contentInfo {
    display: flex;
    color: ${(props) => props.theme.colors.gray};
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    width: 70%;
    .number {
      font-size: 20px;
    }

    .bank-name {
      font-size: 16px;
    }

    .default {
      order: 2;
      font-size: 12px;
    }

    .default2 {
      order: 1;
      font-size: 14px;
    }

    div {
      margin-left: 4px;
    }

    .contentInfo {
      flex-direction: column;
    }
  }
`;

export const Subtitle2 = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .alert-icon {
    width: 40px;
    height: 35px;
    margin-right: 5px;
  }
`;

export const Subtitle3 = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .navbar {
    width: 624px;
    height: 28px;
    margin-bottom: 30px;
  }

  .info {
    width: 295px;
    height: 50px;
    margin-bottom: 20px;
  }

  .title-option {
    width: 173px;
    height: 15px;
    margin-bottom: 20px;
  }

  .option {
    width: 624px;
    height: 75px;
    margin-bottom: 20px;
  }

  .payment {
    width: 624px;
    height: 40px;
    margin-top: 10px;
  }

  @media screen and (max-width: 960px) {
    .navbar {
      width: 150px;
    }

    .option {
      width: 330px;
    }

    .payment {
      width: 319px;
    }
  }
`;

export const Button = styled.button<{ color: string; loading?: boolean }>`
  height: 60px;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: ${(props) => (props.loading ? '0 24px' : '19px 24px')};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;

  p {
    margin-left: 8px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PaymentCard = styled.div`
  width: 100%;
  height: 68px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin-bottom: 12px;
  padding: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .text {
    padding: 6px 0;
    font-size: 20px;
    color: ${(props) => props.theme.colors.black};
    flex-grow: 10;
    @media screen and (max-width: 960px) {
      padding: 10px 0;
    }
  }

  .icon {
    flex-grow: 1;
  }

  @media screen and (max-width: 960px) {
    height: 72px;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 18px;

    .text {
      font-size: 16px;
    }
  }
`;
